import AtomicSubscription from './atomic-subscription';

class CaseSubscription {
  private subscriptions: { [caseId: string]: AtomicSubscription };
  constructor() {
    /**
     * {
     *  "<caseId>": <Atomic Subscription>
     * }
     */
    this.subscriptions = {};
  }

  getOrCreateSubscription(caseId: string) {
    if (!this.subscriptions[caseId]) {
      const criteria = {
        caseId
      };

      this.subscriptions[caseId] = new AtomicSubscription('CASE', criteria);
    }
    return this.subscriptions[caseId];
  }
}

export default new CaseSubscription();
